/***
 *
 *   APP LAYOUT
 *   Main application layout containing the navigation
 *   and header (title, secondary nav and signed in user)
 *
 **********/

import { useContext } from "react";
import { AppNav, AuthContext, Footer } from "@/components/lib";
import whistleImg from "@/images/whistle.svg";
import star from "@/images/star_icon.svg";
import football from "@/images/football_icon.svg";
import calendar from "@/images/calendar_icon.svg";
import phone from "@/images/phone_icon.svg";
import Style from "./app.module.scss";

const IconNavBar = ({ image, name }) => (
  <img src={image} alt={name} className="w-6 -ml-1" />
);

export function AppLayout(props) {
  const authContext = useContext<any>(AuthContext);
  const { user } = authContext;

  const items = [
    {
      label: "Players",
      customIcon: <IconNavBar image={football} name="Players" />,
      link: "/players"
    },
    {
      label: "Coaches",
      customIcon: <IconNavBar image={whistleImg} name="Coaches" />,
      link: "/coaches"
    },
    {
      label: "Schedule",
      customIcon: <IconNavBar image={calendar} name="Schedule" />,
      link: "/schedule"
    },
    user
      ? {
          label: "Recruiting",
          customIcon: <IconNavBar image={star} name="Recruiting" />,
          link: "/recruiting"
        }
      : null,
    {
      label: "Contact",
      customIcon: <IconNavBar image={phone} name="Contact" />,
      link: "/contact"
    },
    user?.profileName
      ? {
          label: "My Profile",
          icon: "user",
          link: "/" + user.profileName
        }
      : null
  ].filter(Boolean);

  return (
    <>
      <AppNav items={items} />

      <main className={Style.app}>{<props.children {...props.data} />}</main>

      <Footer />
    </>
  );
}
